import { render, staticRenderFns } from "./AccountsDefault.vue?vue&type=template&id=60b00012&"
import script from "./AccountsDefault.vue?vue&type=script&lang=js&"
export * from "./AccountsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports